import withFeature from "./feature/feature";
import withErrorBoundary from "./error/error";

export { withFeature, withErrorBoundary };
